import React, { useState } from "react";
import { useEffect } from "react";
import HttpApiUtil from "../../../../ApiUtils/HttpApiUtil";
import AnimatedTimer from "./AnimatedTimer";
import FailedPayment from "./FailedPayment";
import PaymentOptionForAndroid from "./PaymentOptionForAndroid";
import PendingStatus from "./PendingStatus";
import "./Styles.css";
import SuccessPage from "./successPage";
import ProcessingPaymentScreen from "./ProcessingPaymentScreen";
import { useSelector } from "react-redux";
const ObjHttpApiUtil = new HttpApiUtil();

const AndroidScreen = ({ data={ },screen,setScreen,checkStatus, getUpiLink, redirectLink, showUpiCollect, clearVpa }) => {
  const timer = 120;
  // const [screen, setScreen] = useState("defaultScreen");
  const token = useSelector(
    (state) => state.merchantPaymentDataFetchingReducer.token
  );

  const handleScreen = (screen) => {
    switch (screen) {
      case "PENDING_STATUS":
        return <PendingStatus  setScreen={setScreen} />;
      case "ANIMATED_TIMER":
        return (
          <AnimatedTimer
            transactionId={data.pine_pg_transaction_id}
            timer={timer}
            setScreen={setScreen}
            ObjHttpApiUtil={ObjHttpApiUtil}
            checkStatus={checkStatus}
          />
        );
      case "TIMER_PROCESSING":
        return (
          <ProcessingPaymentScreen
            transactionId={data.pine_pg_transaction_id}
            setScreen={setScreen}
            ObjHttpApiUtil={ObjHttpApiUtil}
            checkStatus={checkStatus}

          />
        );

      case "FAILED_PAYMENT":
        return <FailedPayment setScreen={setScreen} />;
      case "SUCCESS_PAGE":
        return (
          <SuccessPage
            setScreen={setScreen}
          />
        );
      default:
        return <PaymentOptionForAndroid data={data} setScreen={setScreen} transactionId={data.pine_pg_transaction_id}
        pageTimer={timer}
        ObjHttpApiUtil={ObjHttpApiUtil}
        checkStatus={checkStatus}
        getUpiLink={getUpiLink} redirectLink={redirectLink} showUpiCollect={showUpiCollect} clearVpa={clearVpa}/>;
    }
  };

  return (
    <div className="payment-pay-options">
      {handleScreen(screen)}
      <form
        id="UPIAuthForm"
        method="POST"
        action={
          process.env.REACT_APP_PG_CONTROLLER + "UPI/SubmitUpiTransaction"
        }
      >
        <input class="form-control" type="hidden" value={""} id="apitimeout" />
        <input
          class="form-control"
          type="hidden"
          name="token"
          value={token}
          id="PinePGTransactionID"
        />
      </form>
    </div>
  );
};

export default AndroidScreen;
